import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fleet-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
